/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GeoTestPatchScheduleDTO { 
    /**
     * Test start date in ISO-8601 format
     */
    startDate: string;
    /**
     * Test end date in ISO-8601 format
     */
    endDate: string;
    /**
     * Type of geo test (Holdout, Scale, Contribution). Maps to the test cell type
     */
    testType?: GeoTestPatchScheduleDTO.TestTypeEnum;
}
export namespace GeoTestPatchScheduleDTO {
    export type TestTypeEnum = 'Holdout' | 'Scale' | 'Contribution';
    export const TestTypeEnum = {
        Holdout: 'Holdout' as TestTypeEnum,
        Scale: 'Scale' as TestTypeEnum,
        Contribution: 'Contribution' as TestTypeEnum
    };
}


